<app-banner [info]="true" heading="Review management" subHeading="Manage revalidation reviews">

  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

  </div>

</app-banner>

<div class="content spread">

  <div class="row">
    <div class="col-lg-12">
      <section>
        <div class="section-header-container">
          <h2 style="flex-grow: 1">Global review search</h2>
          @if (loadingGlobalSearchResult) {
            <app-spinner [small]="true"></app-spinner>
          }
          <button (click)="toggleSearch()" aria-label="Search for reviews via the review title" class="btn">
            <i class="fa fa-search"></i>
            <span>search</span>
          </button>
        </div>
        <div class="section-body-container fadein">
          <app-collapsible [trigger]="searching">
            <div class="ml-3 no-boxes form-inline mb-3">
              <div class="form-group reg-number">
                <input #regNumber placeholder="Search review title..." [(ngModel)]="searchCriteria.uniqueName" type="text"
                  name="regNumber" class="form-control " />

                  <button class="btn btn-primary ml-2" [disabled]="!searchCriteria.uniqueName"
                  (click)="search()">Search</button>
                  <button class="btn btn-default ml-2" (click)="clearSearch()">Clear</button>
                </div>
              </div>
            </app-collapsible>
            <app-collapsible [trigger]="uniqueNameResults">

              <div class="content no-boxes fadein">
                <ng-container>
                  @if (data?.length > 0) {
                    <div style="padding-bottom: 20px">
                      <table class="table">
                        <thead>
                          <tr>
                            <th style="width: 80px">Title</th>
                            <th style="width:100px">Registrant</th>
                            <th style="width: 140px">Stage</th>
                            <th>Reviewers</th>
                            <th>Indicators</th>
                            <!---  <th>Remediation</th>-->
                            <th>Updated</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (row of data; track row) {
                            <tr [class.excluded]="row.excludedFromReview"
                              [class.failed]="row.failedCoreCriteria">
                              <td class="clickable" (click)="openReview(row)">{{ row.title }}</td>
                              <td class="clickable" (click)="openReview(row)"> @if (row.failedCoreCriteria) {
                                <i appTooltip="Core criteria not met"
                                class="fa fa-warning"></i>
                                }&nbsp;{{ row.registrationNumber }}
                              </td>
                              <td>{{ ReviewStage[row.reviewStage] | caseSplit }}</td>
                              <!--- <td>{{ row.dateAssigned }}</td> -->
                              <td style="width: 360px;">
                                <!-- <div style="display:flex; align-items: center">
                                <div [class.hidden]="editing.id === row.id" style="flex-grow:1"><span
                                class="primary">{{ row.leadReviewerName }}</span> | <span
                              class="secondary">{{ row.secondaryReviewerName }}</span>
                            </div>
                            <button (click)="toggleEdit(row)" class="btn-edit">
                              <i class="fa fa-pencil" [class.fa-pencil]="editing.id !== row.id"
                              [class.fa-close]="editing.id === row.id"></i>
                            </button>
                          </div>
                          <app-collapsible [trigger]="editing.id === row.id">
                            <ng-container *ngIf="editing.id === row.id">
                              <app-change-reviewers [editing]="editing" [row]="row" (changed)="cancelEdit()">
                              </app-change-reviewers>
                            </ng-container>
                          </app-collapsible> -->
                        </td>
                        <td> <span class="primary">{{ PerformanceIndicator[row.leadReviewerIndicator] | caseSplit }}
                        </span> |
                        <span
                        class="secondary">{{ PerformanceIndicator[row.secondaryReviewerIndicator] | caseSplit }}</span>
                      </td>
                      <!---  <td> {{ row.inRemediationThisYear | friendlyBoolean }}</td>-->
                      <td> {{ row.lastUpdated | date: 'dd/MM/yyyy' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="no-data">
              <p>
                No reviews that matched {{ searchCriteria.uniqueName }}
              </p>
            </div>
          }
        </ng-container>

      </div>
    </app-collapsible>
  </div>
</section>
</div>
</div>

<div class="row">
  <div class="col-lg-12">
    <section>
      <div class="section-header-container">
        <h2 style="flex-grow:1">Backlog</h2>

        @if (loadingBacklog) {
          <app-spinner [small]="true"></app-spinner>
        } @else {
          <button class=" btn btn-default " routerLink="backlog"> <i class="fa fa-list">
            </i><span>view</span></button>
            <button (click)="togglePanel('sampling')" aria-label="Create sampling" class="btn no-focus"
              [class.open]="panel==='sampling'">
              <i class="fa fa-database"></i>
              <span>sample</span>
            </button>
            <button [disabled]="backlogItems.length === 0" (click)="togglePanel('cohort')"
              aria-label="Create review cohort" class="btn no-focus" [class.open]="panel==='cohort'">
              <i class="fa fa-calendar"></i>
              <span>allocate</span>
            </button>
          }

        </div>

        <app-collapsible [trigger]="panel==='sampling'">
          <div class="dropdown-panel">
            <h4>
              <span>Select for review</span>
              <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
            </h4>
            <app-sampling (created)="samplingCreated()" [samplings]="samplingsList"></app-sampling>
          </div>
        </app-collapsible>

        <app-collapsible [trigger]="panel==='cohort'" class="dropdown-panel-container">
          <div class="dropdown-panel">

            <h4>
              <span>Allocate to reviewers</span>
              <button (click)="panel=undefined" class="btn-default btn-close"><i class="fa fa-close"></i></button>
            </h4>

            <app-review-cohort-create (created)="cohortCreated()"></app-review-cohort-create>

          </div>
        </app-collapsible>
        @if (!loadingBacklog && !!backlogItems.length) {
          <div class="section-body-container fadein">
            <div class="review-backlog-info">
              {{ totalSubmissions }} submissions have been selected for review over
              {{ backlogItems.length }} renewal cohorts between
              {{ backlogItems[0].renewalDate | date: 'dd/MM/yyyy' }} and
              {{ backlogItems[backlogItems.length - 1].renewalDate | date: 'dd/MM/yyyy' }}, and have yet to be allocated
              to reviewers.
            </div>
            <div class="review-backlog ">
              @for (item of backlogItems; track item) {
                <div [appTooltip]="item.tooltip" class="backlog-item clickable"
                  [style.width]="item.proportionalWidth" [style.backgroundColor]="item.colour"
                  (click)="openBacklog(item.renewalDate)">
                </div>
              }
            </div>
            <div style="display:flex">
              <div class="date">{{ backlogItems[0].renewalDate | date: 'dd/MM/yyyy' }}</div>
              <div style="flex-grow: 1"></div>
              <div class="date">{{ backlogItems[backlogItems.length - 1].renewalDate | date: 'dd/MM/yyyy' }}</div>
            </div>
          </div>
        }

        @if (!loadingBacklog && backlogItems.length === 0 && panel !=='cohort') {
          <div class="section-body-container fadein"
            >
            <p class="empty-info">There's nothing in the backlog. You can add reviews to the backlog by choosing
              &nbsp;<span (click)="togglePanel('sampling')" aria-label="Create sampling">
              <i class="fa fa-database"></i>
              <span>sample</span>
            </span>.
          </p>
        </div>
      }

    </section>
  </div>
</div>

<div class="row">

  <div class="col-lg-12">

    <section>
      <div class="section-header-container">
        <h2 style="flex-grow: 1">Allocated</h2>
        @if (loadingCohorts) {
          <app-spinner [small]="true"></app-spinner>
        }
      </div>
      @if (!loadingCohorts && !!reviewCohorts.length) {
        <div class="section-body-container fadein">
          <table class="table">
            <thead>
              <tr>
                <!--  <th style="width: 100px">Created</th>-->
                <th style="width: 60px">Deadline</th>
                <th style="width: 100px">Status</th>
                <th class="text-right pr-4" style="width: 40px">Total</th>
                <th class="text-right pr-4" style="width: 70px">Review</th>
                <th class="text-right pr-4" style="width: 70px">QA</th>
                <th class="text-right pr-4" style="width: 70px">QA completed</th>
                <th class="text-right pr-4" style="width: 70px">QM completed</th>
                <th class="text-right pr-4" style="width: 70px">CCNM</th>
                <th class="text-right pr-4" style="width: 70px">Published</th>
                <th class="text-right pr-4" style="width: 70px">Excluded</th>
                <th style="width: 80px"></th>
              </tr>
            </thead>
            <tbody>
              @for (row of reviewCohorts; track row) {
                <tr [class.pending]="row.pending" [class.completed]="row.completed">
                  <!---    <td>
                {{ row.createdDate | utcDate }} </td>-->
                <td>
                {{ row.reviewDeadline | utcDate }} </td>
                <td>
                  <!--- <i style="font-size:1.4em" class="fa {{cohortStatusIcon}}"></i>-->
                  <div>
                    {{ CohortStatus[row.status] | caseSplit }}
                  </div>
                </td>
                <td class="text-right pr-4">
                  <div [class.clickable]="row.status === CohortStatus.PendingCommit" (click)="openPendingCommit(row)">
                    {{ row.total  || '-' }}
                  </div>
                </td>
                <td class="text-right pr-4 {{ReviewView[1]}}">
                  <div [class.clickable]="row.status !== CohortStatus.PendingCommit && !!row.inExternalReviewStage"
                    (click)="showExternalReviewCohort(row)">
                    @if (row.status !== CohortStatus.PendingCommit) {
                      <span
                      >{{ row.inExternalReviewStage || '-' }}</span>
                    }
                  </div>
                  @if (row.status === CohortStatus.PendingCommit) {
                    <span>
                      -
                    </span>
                  }
                </td>
                <td class="text-right pr-4 {{ReviewView[2]}}">
                  <div [class.clickable]="!!row.inQualityAssuranceStage" (click)="showQaCohort(row, { reviewView: 2 })">
                    {{row.inQualityAssuranceStage || '-'}}
                  </div>
                </td>
                <td class="text-right pr-4 {{ReviewView[3]}}">
                  <div [class.clickable]="!!row.qualityAssuranceCompleted"
                    (click)="showQaCohort(row, { reviewView: 3 })">
                    {{row.qualityAssuranceCompleted || '-'}}
                  </div>
                </td>
                <td class="text-right pr-4 {{ReviewView[4]}}">
                  <div [class.clickable]="!!row.qualityAssuranceManagerCompleted"
                    (click)="showQaCohort(row, { reviewView: 4 })">
                    {{row.qualityAssuranceManagerCompleted || '0'}} / {{ row.managerTenPercent }}
                  </div>
                </td>
                <td class="text-right pr-4 {{ReviewView[5]}}">
                  <div [class.clickable]="!!row.coreCriteriaNotMet" (click)="showQaCohort(row, { reviewView: 5 })">
                    {{row.coreCriteriaNotMet || '-'}}
                  </div>
                </td>
                <td class="text-right pr-4">
                  <div [class.clickable]="!!row.published" (click)="showQaCohort(row, { reviewView: 6 })">
                    {{row.published || '-'}}
                  </div>
                </td>
                <td class="text-right pr-4">
                  <div [class.clickable]="!!row.excludedFromPublish"
                    (click)="showQaCohort(row, { excludedFromPublish: true })">
                    {{row.excludedFromPublish || '-'}}
                  </div>
                </td>
                <td class="text-center">
                  <!--*ngIf="!row.published"-->
                  @if (!row.completed && !row.pending) {
                    <button class="btn btn-default btn-block btn-publish"
                      [disabled]="!row.publishable || row.publishing" (click)="publish(row)">@if (!row.publishing) {
                      <span
                      >Publish</span>
                    }
                    @if (row.publishing) {
                      <span><i class="fa fa-spin"></i></span>
                    }
                  </button>
                }
                @if (row.completed) {
                  <i class="fa fa-check"></i>
                }
                @if (row.pending) {
                  <i style="font-size: 1.5em;color: #2996d6;" class="fa fa-clock-o"></i>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!loadingCohorts && reviewCohorts.length === 0) {
    <div class="section-body-container fadein">
      <p class="empty-info">There are no reviews allocated. @if (backlogItems.length > 0) {
        <span>You can allocate
          them to reviewers by choosing &nbsp;<span (click)="togglePanel('cohort')"
          aria-label="Create review cohort">
          <i class="fa fa-calendar"></i>
          <span>allocate</span>
        </span> in the Backlog panel.</span>
      }</p>
    </div>
  }
</section>


</div>
</div>



</div>